import React from 'react';
import { useSelector } from 'react-redux';

// Components
import Admin2Tools from '../Admin2Tools/Admin2Tools';
import Admin2Filters from '../Admin2Filters/Admin2Filters';
import Admin2Table from '../Admin2Table/Admin2Table';
import Admin2Chart from '../Admin2Chart/Admin2Chart';
import Admin2Map from '../Admin2Map/Admin2Map';

// Store
import { $indicatorSelected } from '../../store/slices/admin2EstimatesSlice';
import { $toolSelected } from '../../store/slices/admin2ToolsSlice';

// Configs
import { TOOLS_OPTIONS_OBJECT } from '../../configs/tools.configs';

// Styles
import './App.scss';

const App = () => {
  const indicatorSelected = useSelector($indicatorSelected);

  const toolSelected = useSelector($toolSelected);

  return (
    <div className='row'>
      <Admin2Filters />

      <Admin2Tools />

      <section className='row'>
        <div className='col-lg-12 col-md-12'>
          <h3 className='admin-2-estimates__body-title'>{indicatorSelected?.label}</h3>
        </div>
      </section>

      <div className='tool-container__wrapper'>
        <div className={'tool-container'} style={{ zIndex: toolSelected !== TOOLS_OPTIONS_OBJECT.map.label ? -1 : 1 }}>
          <Admin2Map />
        </div>

        {toolSelected === TOOLS_OPTIONS_OBJECT.table.label && (
          <div>
            <Admin2Table />
          </div>
        )}

        {toolSelected === TOOLS_OPTIONS_OBJECT.chart.label && (
          <div>
            <Admin2Chart />
          </div>
        )}
      </div>
    </div>
  );
};

export default App;
